var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      "show-spinner": _vm.isLoading,
      "show-modal": _vm.showModal,
      "modal-extra-large": true,
      "modal-dialog-scrollable": true,
      "primary-footer-button-translation": _vm.$t("pages.payroll.download"),
      "loading-primary-footer-button": _vm.isLoading,
    },
    on: _vm._d({}, [
      _vm.saveEvent,
      _vm.onSaveButtonClicked,
      _vm.closeEvent,
      _vm.onCloseButtonClicked,
      _vm.secondaryEvent,
      _vm.onCloseButtonClicked,
    ]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [_c("pdf-js-viewer", { attrs: { src: _vm.src } })]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }